import { Button } from "@heroui/react";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

interface FileUploadProps {
	onChange?: (file: File | undefined) => void;
	file?: File | undefined; //any
	label?: string;
	errorMessage?: string;
	isInvalid?: boolean;
}

export default function FileUpload(props: FileUploadProps) {
	const { file, onChange, label, errorMessage } = props;

	const onDrop = useCallback((acceptedFiles: File[]) => {
		const file_reader = acceptedFiles[0];
		onChange?.(file_reader);
	}, []);

	const { getRootProps, getInputProps, open } = useDropzone({
		onDrop,
		multiple: false,
		noClick: true,
		noKeyboard: true,
	});

	return (
		<div className="mx-auto grid w-full max-w-sm gap-2" {...getRootProps()}>
			<input {...getInputProps()} />
			{label}
			<div className="flex w-full items-center gap-4 rounded-md border border-gray-200 p-4 dark:border-gray-700">
				<FileIcon />
				<div className="flex w-full items-center justify-start">
					<span> גרור קובץ או </span>
					<Button size="sm" variant={"ghost"} className="mr-1 p-0" onPress={open}>
						<FilePlusIcon /> העלה קובץ{" "}
					</Button>
				</div>
				{!!file && (
					<Button
						variant="bordered"
						onPress={() => {
							onChange?.(undefined);
						}}
					>
						<XIcon />
						<span className="sr-only">מחק קובץ</span>
					</Button>
				)}
			</div>
			<div className="text-red-400">{errorMessage ?? ""}</div>
		</div>
	);
}
function FileIcon() {
	return (
		<svg
			className="h-6 w-6"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
			<polyline points="14 2 14 8 20 8" />
		</svg>
	);
}

function FilePlusIcon() {
	return (
		<svg
			className="h-6 w-6"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
			<polyline points="14 2 14 8 20 8" />
			<line x1="12" x2="12" y1="18" y2="12" />
			<line x1="9" x2="15" y1="15" y2="15" />
		</svg>
	);
}

function XIcon() {
	return (
		<svg
			className="h-4 min-h-4 w-4 min-w-4"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M18 6 6 18" />
			<path d="m6 6 12 12" />
		</svg>
	);
}
